import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Display,
  Heading3,
  Heading4,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

import { HowGoustoFoodBoxesWorkTypes } from '../../../../../types'
import { OrderedCol } from '../OrderedCol'
import { LandingPageButton } from '../../../../../components'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../../types/tracking'
import { ResponsiveImage } from '../../../../../components/ResponsiveImage'

import whyGoustoMobileWebp from '../../assets/whygousto-mobile.webp'
import whyGoustoDesktopWebp from '../../assets/whygousto-desktop.webp'
import whyGoustoJpg from '../../assets/whygousto.jpg'

export function WhyGousto({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <>
      <OrderedCol order={7}>
        <Box paddingRight={[10]}>
          <Heading3>Why Gousto? Glad you asked</Heading3>
          <Space size={3} />
          <Heading4 size={6}>No More Supermarket Stress</Heading4>
          <Body2 size={4}>
            Forget wandering aimlessly through the aisles or caving into another sad takeaway. We’ve
            got you covered with recipes you’ll actually look forward to.
          </Body2>
          <Space size={4} />
          <Heading4 size={6}>Tasty and Good for You</Heading4>
          <Body2 size={4}>
            Food box delivery means fresh, wholesome ingredients delivered to your door that’ll make
            both your tastebuds and your health goals happy.
          </Body2>
          <Space size={4} />
          <Heading4 size={6}>Meal Planning = Done</Heading4>
          <Body2 size={4}>
            You get easy-to-follow recipes, all pre-measured and ready to go. No guesswork, no food
            waste, just good eats.
          </Body2>
          <Space size={4} />
          <Body2 size={4}>
            Oh, and did we mention? Our menu is the biggest out there, with over 175 recipes to
            choose from every week.
          </Body2>
          <Space size={6} />
        </Box>
        <Box
          display={Display.Flex}
          justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
        >
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={FoodBoxPageSections.FOOD_BOX_SECTION}
            target={TargetUri.SIGNUP}
            action={TrackingActions.CLICK_GET_STARTED}
          >
            Join millions cooking better
          </LandingPageButton>
        </Box>
        <Space size={[6, null, null, 0]} />
      </OrderedCol>
      <OrderedCol
        order={8}
        display={Display.Flex}
        alignItems={AlignItems.FlexStart}
        justifyContent={JustifyContent.Center}
      >
        <Box maxWidth={[null, null, null, '600px']} width="100%">
          <ResponsiveImage
            mobileWebp={whyGoustoMobileWebp}
            desktopWebp={whyGoustoDesktopWebp}
            fallbackSrc={whyGoustoJpg}
            alt="Customer serving a delicious Sweet Potato And Black Bean tomato Stew"
            style={{ maxHeight: '457px' }}
            fit="cover"
          />
        </Box>
      </OrderedCol>
    </>
  )
}
